module.exports = __webpack_public_path__ + "static/img/weatherroute2.489a084.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/weatherroute2.png
// module id = VVsT
// module chunks = 0